<template>
  <div :class="{'home-holiday-promo': true, 'home-holiday-promo--no-cta': !includeCta}">
    <div class="container">
      <div class="content">
        <h1 class="title">Brighten your holidays with our best price ever.</h1>
        <p class="subtitle">{{ promoPrice }} to access over 1000 hours of award-winning Luminary Originals for the year - a savings of 60% off the monthly price.</p>
        <div class="button-wrapper">
          <div v-if="includeCta" class="button-container">
            <el-button
              ref="cta"
              class="el-button--primary cta-button"
              @click="handleSubscribeClick('home_subscribe_click')">
              Start Listening
            </el-button>
            <p class="disclaimer-text"> <span style="color: rgb(193,193,193);">Cancel Anytime.</span>
              <router-link
                :to="termsLink"
                color="primary"
                target="_blank"
                class= "terms"
                data-test="link-terms"
              >
                Terms apply
              </router-link>
            </p>
          </div>
          <app-store-links v-else />
        </div>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <div
        v-show="!isScrollingBtnVisible"
        :class="{'button-wrapper': true, 'button-wrapper_fixed': true}"
      >
        <el-button
          class="el-button--primary cta-button"
          @click="handleSubscribeClick('home_subscribe_click')">
          Start Listening
        </el-button>
      </div>
    </transition>
  </div>
</template>

<script>
import AppStoreLinks from '@/components/AppStoreLinks';
import HolidayPromo from '@/services/HolidayPromo';
import { getServices } from '@/services/serviceProvider';

const [holidayPromo] = getServices([HolidayPromo]);

export default {
  components: {
    AppStoreLinks,
  },
  props: {
    includeCta: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      scrollingBtnBB: null,
    };
  },
  computed: {
    isScrollingBtnVisible() {
      if (!this.scrollingBtnBB) return true;
      const { height, y } = this.scrollingBtnBB;
      return y + height > 0;
    },
    promoPrice() {
      const { country } = this.$store.getters;
      return holidayPromo.modifications[country]
        ? holidayPromo.modifications[country].yearly.displayPromoPrice
        : '';
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleSubscribeClick(btnId) {
      this.$analytics.track('Home Subscribe Click', {
        screen_name: this.$route.name,
        path: this.$route.path,
        btnId,
      });
      this.onStartFreeTrialClick();
    },
    handleScroll() {
      this.updateScrollingBtn();
    },
    updateScrollingBtn() {
      if (!this.$refs.cta) return;
      this.scrollingBtnBB = this.$refs.cta.$el.getBoundingClientRect();
    },
  },
};

</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables.scss";
$vertical-shift: 0px;

.home-holiday-promo {
  width: 100%;
  position: relative;
  margin: 0;
  padding: 0;
  @media (max-width: $xs) {
    padding-top: 183px;
    max-height: 470px;
    padding-bottom: 32px;
  }
  @media (max-width: $xxs) {
    padding-top: 133px;
    max-height: 420px;
    padding-bottom: 32px;
  }
  &.home-holiday-promo--no-cta {
    .subtitle {
      font-size: 18px;
    }
    @media (max-width: $xs) {
      .container {
        height: 190px;
        margin-top: -$vertical-shift;
      }
      .subtitle {
        display: none;
      }
    }
  }
}

.home-holiday-promo::before {
  background-color: $dark-background;
  background-image: linear-gradient(90deg, $dark-background 0%, rgba(0,0,0,0) 45%, rgba(0,0,0,0)), url(../../../assets/images/web2/home/HolidayPromo-2828.jpg);
  background-size: auto 100%;
  content: "";
  position: absolute;
  top: 0;
  background-repeat: no-repeat;
  background-position: right;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  opacity: 1;
  @media (max-width: 1360px){
    background-image: linear-gradient(90deg, $dark-background 0%, rgba(0,0,0,0) 55%, rgba(0,0,0,0)),  url(../../../assets/images/web2/home/HolidayPromo-1414.jpg);
    background-size: auto 100%;
  }
  @media (max-width: $xs){
    height: 150px;
    background-image: url(../../../assets/images/web2/home/HolidayPromo-1152.png), linear-gradient(90deg, $dark-background 0%, rgba(0,0,0,0) 45%);
    background-position: center center;
    background-size: cover;
  }
  @media (max-width: $xxs){
    height: 100px;
    background-image: url(../../../assets/images/web2/home/HolidayPromo-576.png);
    background-position: center center;
    background-size: cover;
  }
}
.home-holiday-promo::after {
  z-index: 2;
  opacity: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: right;
  background-image: linear-gradient(90deg, $dark-background 0%, rgba(0,0,0,0) 45%);
}

.container {
  max-width: 1600px;
  margin: 0 auto;
  width: auto;
  display: flex;
  flex-flow: row nowrap;
  padding-left: 87px;
  align-items: center;
  justify-content: left;
  height: 467px;
  @media (max-width: 1410px){
    height: 420px;
  }
  @media (max-width: 1300px){
    height: 380px;
  }
  @media (max-width: $lg) {
    height: 380px;
  }
  @media (max-width: 1079px){
    height: 380px;
  }
  @media (max-width: $md) {
    height: 323px;
  }
  @media (max-width: $sm) {
    padding-left: 55px;
  }
  @media (max-width: $xs) {
    padding-left: 0;
  }
}

.content {
  opacity: 1;
  position: relative;
  z-index: 2;
  flex: 0 0 420px;
  @media (max-width: $md) {
    flex: 0 0 312px;
  }
  @media (max-width: $sm) {
    flex: 0 0 270px;
  }
  @media (max-width: $xs) {
    flex: 1 1 auto;
  }
}

.title {
  color: $white;
  font-family: $serif;
  font-size: 42px;
  line-height: 42px;
  font-weight: 500;
  letter-spacing:0px;
  text-align: left;
  margin: 0 auto 6px;
  max-width: 600px;
  @media (max-width: $md) {
    max-width: 500px;
    font-size: 28px;
    line-height: 33px;
    margin: 0 auto 12px;
  }
  @media (max-width: $sm) {
    font-size: 24px;
    line-height: 28px;
  }
  @media (max-width: $xs) {
    margin: 0 auto 20px;
    max-width: 320px;
    text-align: center;
    font-size: 36px;
    line-height: 42px;
  }
}

.subtitle {
  color: $white;
  max-width: 428px;
  text-align: left;
  font-size: 16px;
  line-height: 21px;
  margin-bottom: 25px;
  @media (max-width: $sm) {
    margin-bottom: 12px;
    font-size: 12px;
    line-height: 19px;
  }
  @media (max-width: $xs) {
    text-align: center;
    margin: 0 auto;
    font-size: 18px;
    line-height: 23px;
    margin-bottom: 36px;
    max-width: 250px;
  }
}

.cta-button {
  min-width: 232px;
  padding: 16px 28px;
  font-size: 16px;
}

.disclaimer-text {
  text-align: center;
  color: $white;
  font-size: 12px;
  line-height: 14px;
  @media (max-width: $xs) {
    text-align: center;
  }
  .terms {
    text-decoration: underline;
    color: $white;
  }
}

.button-wrapper {
  display: flex;
  justify-content: left;
  margin-left: 0;
  @media (max-width: $xs) {
    text-align: center;
    display: block;
    margin-left: auto;
  }
  .button-container {
    text-align: center;
  }
  .el-button--primary {
    margin-left: 0;
    @media (max-width: $sm) {
      margin-bottom: 6px;
    }
  }
  &_fixed {
    display: none;
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 1000;
    @media (max-width: $xs) {
      display: block;
    }
  }
}

</style>
